import { ClassType } from '@frontend/common';
import { Dropdown, DropdownItem, HorizontalButtonGroupButton, Spinner } from '@frontend/components/common';
import React from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';

import useObjectListButtonGroup from './object-list-button-group.controller';

const ID = 'object-list-button-group';
export interface ObjectListButtonGroupProps {
    buttons: HorizontalButtonGroupButton[];
}

const ObjectListButtonGroup = (props: ObjectListButtonGroupProps) => {
    const viewProps = useObjectListButtonGroup(props);

    const getType = (button: HorizontalButtonGroupButton): ClassType => {
        if (button.type) {
            return button.type;
        } else {
            if (button.className?.includes('primary')) return ClassType.PRIMARY;
            if (button.className?.includes('success')) return ClassType.SUCCESS;
            if (button.className?.includes('warning')) return ClassType.WARNING;
            if (button.className?.includes('danger')) return ClassType.DANGER;
            if (button.className?.includes('info')) return ClassType.INFO;
        }
        return ClassType.SECONDARY;
    };

    const color = (button: HorizontalButtonGroupButton) => {
        switch (getType(button)) {
            case ClassType.PRIMARY:
                return 'btn-brand-primary';
            case ClassType.SECONDARY:
                return 'btn-brand-secondary';
            case ClassType.SUCCESS:
                return 'btn-status-success';
            case ClassType.WARNING:
                return 'btn-status-warning';
            case ClassType.DANGER:
                return 'btn-status-danger';
            case ClassType.INFO:
                return 'btn-status-info';
            default:
                return 'btn-brand-secondary';
        }
    };
    const getButtonClassName = (button: HorizontalButtonGroupButton) => {
        let className = '';
        if (button.className) className = button.className;
        else className = `btn ${color(button)}`;
        return className;
    };

    return (
        <div
            id={ID}
            data-testid={ID}
            className='flex h-11 flex-row justify-end gap-2'>
            {viewProps.primaryButton && (
                <button
                    id={viewProps.primaryButton.id}
                    onClick={viewProps.primaryButton.onClick}
                    className={getButtonClassName(viewProps.primaryButton) + ' m-0 h-full text-nowrap'}
                    key={viewProps.primaryButton.id}
                    data-testid={viewProps.primaryButton.id}
                    aria-label={viewProps.primaryButton.ariaLabel}
                    title={viewProps.primaryButton.title}
                    disabled={viewProps.primaryButton.disabled}>
                    {viewProps.primaryButton.isLoading ? (
                        <Spinner />
                    ) : (
                        <>
                            {viewProps.primaryButton.icon && <viewProps.primaryButton.icon />}
                            {viewProps.primaryButton.text && (
                                <span className={`${viewProps.primaryButton.icon ? 'ms-2' : ''}`}>{viewProps.primaryButton.text}</span>
                            )}
                        </>
                    )}
                </button>
            )}

            {viewProps.otherButtons.length > 0 && (
                <Dropdown
                    id='object-list-button-group-dropdown'
                    buttonStyle='size-11 hover:bg-background-default hover:cursor-pointer px-4 bg-background-surface rounded-md outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-center items-center gap-2.5'
                    label={<BsThreeDotsVertical />}
                    hideChevron>
                    {viewProps.otherButtons.map((button) => (
                        <DropdownItem
                            id={button.id}
                            onClick={button.onClick}
                            classType={getType(button)}
                            key={button.id}
                            data-testid={button.id}
                            icon={button.icon}
                            label={button.text ?? button.ariaLabel}
                            disabled={button.disabled}
                        />
                    ))}
                </Dropdown>
            )}
        </div>
    );
};

export default ObjectListButtonGroup;
